<template>
  <section>
    <div class="primary-header">
      <h1 data-qa="Content-Theme-Title">
        {{ componentTitle }}
        <small>{{ $route.meta.description }}</small>
      </h1>
    </div>
    <el-tabs @tab-click="setUrl" :value="tabValue">
      <el-tab-pane data-qa="Content-Theme-TabContent-General" name="general">
        <span data-qa="Content-Theme-Tab-General" slot="label">{{ $t('themeTabGeneralText') }}</span>
        <theme-view :file="fieldsData.settingsFile" :loading="loading" :text="fieldsData.settingsText"></theme-view>
      </el-tab-pane>
      <el-tab-pane data-qa="Content-Theme-TabContent-App" name="app">
        <span data-qa="Content-Theme-Tab-App" slot="label">{{ $t('themeTabAppText') }}</span>
        <theme-view :file="fieldsData.appFile" :loading="loading" :text="fieldsData.appText"></theme-view>
      </el-tab-pane>
      <el-tab-pane data-qa="Content-Theme-TabContent-Email" name="email">
        <span data-qa="Content-Theme-Tab-Email" slot="label">{{ $t('themeTabEmailText') }}</span>
        <theme-view :loading="loading" :text="fieldsData.emailBasicText" :title="$t('themeThemeViewBasicSettingsTitle')" data-qa="Content-Theme-Tab-Email-Basic_Settings"></theme-view>
        <theme-view :loading="loading" :text="fieldsData.emailTemplateText" :title="$t('themeThemeViewWelcomeTemplateTitle')" data-qa="Content-Theme-Tab-Email-Welcome_Template"></theme-view>
        <theme-view :loading="loading" :text="fieldsData.ClaimDevicesTemplateText" :title="$t('themeThemeViewClaimDevicesTemplateTitle')" data-qa="Content-Theme-Tab-Email-Claim_Devices_Template"></theme-view>
        <theme-view :loading="loading" :text="fieldsData.emailSenderText" :title="$t('themeThemeViewSenderConfigureTitle')" data-qa="Content-Theme-Tab-Email-Email_Settings"></theme-view>
      </el-tab-pane>
      <el-tab-pane data-qa="Content-Theme-TabContent-Legal" name="legal">
        <span data-qa="Content-Theme-Tab-Legal" slot="label">{{ $t('themeTabLegalText') }}</span>
        <div class="bs-callout">
          <span class="title">{{ $t('themeTabLegalContentTitle') }}</span>
          <i18n path="themeTabLegalContentBody" tag="p">
            <a :href="legalUrl" place="legalUrl" target="_blank">{{ legalUrl }}</a>
            <a :href="muranoTermsUrl" place="muranoTermsUrl" target="_blank">{{ $t('themeTabLegalToSText') }}</a>
          </i18n>
        </div>
        <theme-legal :loading="loading" :text="fieldsData.legalPoliciesText" :title="$t('themeThemeViewLegalPoliciesTitle')"></theme-legal>
      </el-tab-pane>
    </el-tabs>
  </section>
</template>

<script>
  import main from './Theme.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './Theme.scss'
</style>



// WEBPACK FOOTER //
// Theme.vue?cf0e48e0